@if (fetchingUploadedContacts) {
  <section class="step-progress" role="status">
    <progress-circle [progress]="batchProgress.percentage" label="Upload progress" />
    <p class="step-progress__title">
      @if (batchProgress.totalBatches > 0) {
        Adding batch {{ batchProgress.currentBatch }} of {{ batchProgress.totalBatches }}
      } @else {
        Getting the upload ready
      }
    </p>
    <p class="step-progress__hint">
      This import is large, so contacts are added in batches. Keep this page open until it finishes.
    </p>
  </section>
} @else {
  <section class="rv">
    <div class="step-stats">
      <div class="step-stat">
        <span class="step-stat__value">{{ formatCount(totalCount) }}</span>
        <span class="step-stat__label">Rows to add</span>
      </div>
      <div class="step-stat">
        <span class="step-stat__value">{{ formatCount(readyCount) }}</span>
        <span class="step-stat__label"><span class="step-dot" data-tone="ok"></span>Passed the check</span>
      </div>
      <div class="step-stat" [attr.data-tone]="problemCount ? 'bad' : null">
        <span class="step-stat__value">{{ formatCount(problemCount) }}</span>
        <span class="step-stat__label">
          <span class="step-dot" [attr.data-tone]="problemCount ? 'bad' : 'idle'"></span>
          Have problems
        </span>
      </div>
    </div>

    @if (problemCount) {
      <div class="step-notice">
        <span class="bk-sym" aria-hidden="true">info</span>
        <p class="step-notice__text">
          Rows with problems are sent too and will show as failed in the result. Edit or remove them here, or go back
          to Clean up.
        </p>
      </div>
    }

    @if (uploadError) {
      <div class="step-notice is-error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        <p class="step-notice__text">{{ uploadError }}</p>
      </div>
    }

    <uploaded-contacts-review-table />
  </section>
}

<stepper-controls
  class="sticky bottom-0"
  leftButtonLabel="Back"
  [leftButtonDisabled]="fetchingUploadedContacts"
  (leftButtonClick)="goToPrevious()"
  (rightButtonClick)="goToNext()"
  [rightButtonDisabled]="!totalCount"
  [loading]="csvService.isLoading"
  [rightButtonLabel]="submitLabel"
/>
